export const CHAIN_ALERTS_LS_KEY = 'chainAlertsPopup'
export const CHAIN_ALERTS_API_BASE_URL =
  process.env.NEXT_PUBLIC_ALERTS_API_BASE_URL || 'https://prod.simulation.keypersafe.xyz'

export const HOUR_IN_MS = 60 * 60 * 1000
export const CHAIN_ALERTS_DISMISS_DELAY = HOUR_IN_MS * 1
